import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "header-section" }
const _hoisted_3 = { class: "title-text" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "user-section" }
const _hoisted_8 = {
  key: 0,
  class: "user-info"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "tabs-container" }
const _hoisted_11 = { class: "tabs-wrapper" }
const _hoisted_12 = { class: "tabs-actions" }
const _hoisted_13 = { class: "router-view-container" }

import { SwitchButton, Expand, Fold, Menu, Document, Setting, User, House, Star } from '@element-plus/icons-vue';
import * as AllIcons from '@element-plus/icons-vue';
import { ref, watch, onMounted, computed } from 'vue';
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from 'element-plus';
import { useMenuStore } from '@/store/menuStore'; // 导入Pinia store
import { useDetailStore } from '@/store/detailStore';
import { usePageStateStore } from '@/store/pageStateStore';
import { home } from '@/network/index'; // 导入接口
import addDynamicRoutes from '@/utils/addRoutes'; // 导入动态路由
import { clearAuthCache } from '@/utils/authCache';
import SidebarMenuItem from './SidebarMenuItem.vue';

interface MenuItem {
    id: string;
    pid?: string;
    path: string;
    name?: string;
    IsHide?: boolean;
    meta?: {
        title: string;
        icon?: string;
        [key: string]: any;
    };
    children?: MenuItem[];
}

interface TokenInfoResponse {
  response?: {
    uID?: string;
    uRealName?: string;
    uLoginName?: string;
    UserName?: string;
    userName?: string;
    Name?: string;
    name?: string;
    用户名?: string;
    姓名?: string;
  };
}

interface PermissionResponse {
  response?: MenuItem[] | { children?: MenuItem[] };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'layout',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const menuStore = useMenuStore(); // 使用Pinia store
const detailStore = useDetailStore();
const pageStateStore = usePageStateStore();

// 菜单选择处理（正常跳转）
const handleSelect = (key: string) => {
  router.push(key);
}

// 图标映射函数
const getIconComponent = (iconName: string) => {
  if (!iconName) return Menu
  // 如果已经是组件，直接返回
  if (typeof iconName === 'object') {
    return iconName
  }
  
  // fa-* 旧格式映射
  const faIconMap: Record<string, any> = {
    'fa-star': Star,
    'fa-home': House,
    'fa-user': User,
    'fa-cog': Setting,
    'fa-file': Document,
    'fa-menu': Menu,
    'fa-sitemap': Menu,
  }
  
  if (iconName in faIconMap) {
    return faIconMap[iconName]
  }
  
  // 尝试按名称匹配 Element Plus 图标（全局已注册）
  const icons = AllIcons as Record<string, any>
  if (icons[iconName]) {
    return icons[iconName]
  }
  
  // 默认返回Menu图标
  return Menu
}

// 使用Pinia中的侧边栏菜单数据
const sidebarMenus = computed(() => menuStore.sidebarMenus);

const getTextDisplayWidth = (text: unknown) => {
    return Array.from(String(text || '')).reduce((width, character) => {
        return width + (/[^\x00-\xff]/.test(character) ? 16 : 8.5);
    }, 0);
};

const getRequiredMenuWidth = (menus: any[], depth = 0): number => {
    return menus.reduce((maxWidth, item) => {
        if (item?.IsHide || item?.IsButton) return maxWidth;

        const title = item?.meta?.title || item?.name || '';
        const hasChildren = Array.isArray(item?.children) && item.children.length > 0;
        const itemWidth = getTextDisplayWidth(title) + 104 + depth * 16 + (hasChildren ? 16 : 0);
        const childWidth = hasChildren ? getRequiredMenuWidth(item.children, depth + 1) : 0;
        return Math.max(maxWidth, itemWidth, childWidth);
    }, 0);
};

const sidebarWidth = computed(() => {
    const requiredWidth = getRequiredMenuWidth(sidebarMenus.value || []);
    return Math.ceil(Math.min(420, Math.max(220, requiredWidth)));
});

const BreadcrumbTitle = ref('');// 面包屑标题
const Breadcrumb = ref('');// 面包屑二级标题
const currentUserName = ref('');
const activeTab = ref('/home');
const tabs = ref<Array<{ title: string; path: string }>>([
    { title: '首页', path: '/home' }
]);

const canCloseOtherTabs = computed(() => {
    return tabs.value.some(tab => tab.path !== '/home' && tab.path !== activeTab.value);
});

// 缓存版本号（用于强制刷新特定路由的缓存）
const cacheKeys = ref<Record<string, number>>({});

// 获取路由的缓存 key（使用 fullPath 确保不同 query 参数的页面有独立缓存）
const getCacheKey = (fullPath: string) => {
    return `${fullPath}-${cacheKeys.value[fullPath] || 0}`;
};

// 不缓存的路由组件名称列表
const noCacheRoutes = ref<string[]>(['printList']);

const resetLayoutState = () => {
    activeTab.value = '/home';
    tabs.value = [{ title: '首页', path: '/home' }];
    cacheKeys.value = {};
    BreadcrumbTitle.value = '';
    Breadcrumb.value = '';
    currentUserName.value = '';
};


// 侧边栏收缩状态
const isSidebarCollapsed = ref(false);
// 标题显示状态（延迟显示，避免展开过程中换行）
const showTitle = ref(true);

// 添加当前激活菜单
const activeMenu = computed(() => route.path);

// 切换侧边栏收缩状态
const toggleSidebar = () => {
    if (isSidebarCollapsed.value) {
        // 展开：先展开侧边栏，延迟显示标题
        isSidebarCollapsed.value = false;
        showTitle.value = false;
        setTimeout(() => {
            showTitle.value = true;
        }, 300); // 等待展开动画完成
    } else {
        // 收缩：先隐藏标题，再收缩侧边栏
        showTitle.value = false;
        isSidebarCollapsed.value = true;
    }
};

const extractMenusFromPermissionResponse = (res: PermissionResponse): MenuItem[] => {
  const responseData = res?.response
  if (!responseData) return []
  if (Array.isArray(responseData)) return responseData
  if (Array.isArray(responseData.children)) return responseData.children
  return []
}

const resolveUserName = (userInfo: any) => {
  return String(
    userInfo?.uRealName ||
    userInfo?.姓名 ||
    userInfo?.UserName ||
    userInfo?.userName ||
    userInfo?.用户名 ||
    userInfo?.uLoginName ||
    userInfo?.Name ||
    userInfo?.name ||
    ''
  ).trim();
};

// 加载菜单数据（每次进入都重新调用接口）
const loadMenuData = async () => {
  try {
    const token = sessionStorage.getItem('wuyetoken') || localStorage.getItem('wuyetoken');
    if (!token) {
      router.replace({ name: 'login' });
      return;
    }
    
    // 获取用户信息
    const tokenData = await home.GetInfoByToken({ token }) as TokenInfoResponse;
    currentUserName.value = resolveUserName(tokenData?.response);
    const uid = tokenData?.response?.uID;
    if (!uid) {
      console.error('获取用户信息失败');
      menuStore.loadMenusFromStorage(); // 降级使用缓存
      return;
    }
    
    // 获取用户权限菜单
    const permissionRes = await home.GetUserPermission(
      { uid },
      { suppressBusinessErrorMessage: true }
    ) as PermissionResponse;
    const menusData = extractMenusFromPermissionResponse(permissionRes);
    if (menusData.length > 0) {
      
      // 更新本地存储
      localStorage.setItem('wuyemenusJSON', JSON.stringify(menusData));
      
      // 更新菜单store
      menuStore.setMenus(menusData);
      
      // 添加动态路由
      addDynamicRoutes(router, menusData);
    } else {
      console.warn('当前用户无菜单权限');
      const cachedMenus = menuStore.loadMenusFromStorage();
      const syncedAt = Number(localStorage.getItem('menuPermissionSyncedAt') || 0);
      const justSynced = syncedAt > 0 && Date.now() - syncedAt < 10000;
      if (justSynced && cachedMenus.length > 0) {
        menuStore.setMenus(cachedMenus);
        addDynamicRoutes(router, cachedMenus);
        return;
      }
      localStorage.setItem('wuyemenusJSON', JSON.stringify([]));
      localStorage.setItem('buttonPermissions', JSON.stringify([]));
      menuStore.clearMenus();
    }
  } catch (error) {
    console.error('加载菜单数据失败:', error);
    // 出错时降级使用缓存
    menuStore.loadMenusFromStorage();
  }
};

onMounted(() => {
  // 每次进入都重新调用接口获取菜单数据
  loadMenuData();
});

const logout = () => {
    ElMessageBox.confirm('您确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => {
        clearAuthCache();
        resetLayoutState();
        menuStore.clearMenus(); // 退出时清空菜单数据
        detailStore.clearAll();
        pageStateStore.clearSelectedId();
        router.replace({ name: "login" });
        ElMessage({
            type: 'success', message: '已退出',
        })
    }).catch(() => {
        ElMessage({ type: 'info', message: '已取消' })
    })
}

// 添加标签页
const addTab = (route: any) => {
    const { path, fullPath } = route;
    
    // 特殊处理首页
    if (path === '/home') {
        activeTab.value = fullPath;
        return;
    }

    // 使用 fullPath（包含 query 参数）作为唯一标识
    const isExist = tabs.value.some(tab => tab.path === fullPath);
    if (!isExist) {
        // 从处理后的侧边栏菜单中查找对应的标题
        let tabTitle = '未命名';
        
        // 递归查找菜单标题和IsHide状态
        const findTitleInMenus = (menus: MenuItem[], targetPath: string): { title: string | null, isHide: boolean } => {
            for (const menu of menus) {
                if (menu.path === targetPath) {
                    return {
                        title: menu.meta?.title || menu.name || '未命名',
                        isHide: menu.IsHide || false
                    };
                }
                if (menu.children && menu.children.length > 0) {
                    const found = findTitleInMenus(menu.children, targetPath);
                    if (found.title) return found;
                }
            }
            return { title: null, isHide: false };
        };

        const menuInfo = findTitleInMenus(menuStore.sidebarMenus, path);
        
        if (menuInfo.title) {
            tabTitle = menuInfo.title;
            
            // 如果是隐藏菜单项，不添加到标签页
            if (menuInfo.isHide) {
                return;
            }
        } else {
            // 如果在菜单中找不到，尝试从路由 meta 中获取标题
            if (route.meta?.title) {
                tabTitle = route.meta.title;
            } else {
                // 如果路由 meta 中也没有标题，不添加到标签页
                return;
            }
        }

        tabs.value.push({
            title: tabTitle,
            path: fullPath
        });
    }
    activeTab.value = fullPath;
};

// 移除标签页
const removeTab = (targetPath: string) => {
    // 防止删除首页标签
    if (targetPath === '/home') {
        ElMessage({
            type: 'warning',
            message: '首页标签不可删除'
        });
        return;
    }

    const targetIndex = tabs.value.findIndex(tab => tab.path === targetPath);
    if (targetIndex === -1) return;

    const isActive = activeTab.value === targetPath;

    // 非当前激活标签：立即递增缓存版本号（组件未渲染，不会触发重建）
    if (!isActive) {
        cacheKeys.value[targetPath] = (cacheKeys.value[targetPath] || 0) + 1;
    }

    tabs.value.splice(targetIndex, 1);
    if (isActive) {
        const nextTab = tabs.value[targetIndex] || tabs.value[targetIndex - 1];
        if (nextTab) {
            activeTab.value = nextTab.path;
            // 导航完成后再递增版本号，避免 key 变化在当前路由时触发组件重建导致额外接口调用
            router.push(nextTab.path).then(() => {
                cacheKeys.value[targetPath] = (cacheKeys.value[targetPath] || 0) + 1;
            });
        }
    }
};

const invalidateTabCaches = (paths: string[]) => {
    paths.forEach((path) => {
        if (path !== '/home') {
            cacheKeys.value[path] = (cacheKeys.value[path] || 0) + 1;
        }
    });
};

const closeAllTabs = () => {
    const closedPaths = tabs.value.map(tab => tab.path);
    invalidateTabCaches(closedPaths);
    tabs.value = [{ title: '首页', path: '/home' }];
    activeTab.value = '/home';
    if (route.path !== '/home') {
        router.push('/home');
    }
};

const closeOtherTabs = () => {
    const currentTab = tabs.value.find(tab => tab.path === activeTab.value);
    const homeTab = tabs.value.find(tab => tab.path === '/home') || { title: '首页', path: '/home' };
    const keepPaths = new Set(['/home', currentTab?.path].filter(Boolean) as string[]);
    const closedPaths = tabs.value
        .map(tab => tab.path)
        .filter(path => !keepPaths.has(path));
    invalidateTabCaches(closedPaths);
    tabs.value = currentTab && currentTab.path !== '/home'
        ? [homeTab, currentTab]
        : [homeTab];
};

// 点击标签页
const handleClick = (tab: any) => {
    const targetPath = tab.props.name;
    // 如果包含 query 参数，需要解析并传递
    if (targetPath.includes('?')) {
        const [path, queryString] = targetPath.split('?');
        const query: Record<string, string> = {};
        queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            query[key] = decodeURIComponent(value);
        });
        router.push({ path, query });
    } else {
        router.push(targetPath);
    }
};

// 监听路由变化
watch(route, (newRoute) => {
    addTab(newRoute);

    // 重置面包屑
    BreadcrumbTitle.value = '';
    Breadcrumb.value = '';

    // 特殊处理首页
    if (newRoute.path === '/home') {
        BreadcrumbTitle.value = '首页';
        Breadcrumb.value = '首页';
        return;
    }

    // 从Pinia store中的菜单数据查找面包屑
    const findBreadcrumb = (menus: MenuItem[], targetPath: string): { title: string, childTitle: string } | null => {
        for (const item of menus) {
            // 如果是一级菜单
            if (item.path === targetPath) {
                return { title: item.meta?.title || item.name || '', childTitle: '' };
            }

            // 如果是子菜单
            if (item.children) {
                const child = item.children.find(child => child.path === targetPath);
                if (child) {
                    return { 
                        title: item.meta?.title || item.name || '', 
                        childTitle: child.meta?.title || child.name || '' 
                    };
                }
                
                // 递归查找更深层次的子菜单
                for (const childItem of item.children) {
                    if (childItem.children) {
                        const result = findBreadcrumb([childItem], targetPath);
                        if (result) {
                            return { 
                                title: item.meta?.title || item.name || '', 
                                childTitle: result.title 
                            };
                        }
                    }
                }
            }
        }
        return null;
    };

    const breadcrumb = findBreadcrumb(menuStore.sidebarMenus, newRoute.path);
    if (breadcrumb) {
        BreadcrumbTitle.value = breadcrumb.title;
        Breadcrumb.value = breadcrumb.childTitle || breadcrumb.title;
    }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "layout",
    style: _normalizeStyle({ '--sidebar-width': `${sidebarWidth.value}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["side-menu-container", { collapsed: isSidebarCollapsed.value }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "collapse-btn",
            onClick: toggleSidebar
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                (isSidebarCollapsed.value)
                  ? (_openBlock(), _createBlock(_unref(Expand), { key: 0 }))
                  : (_openBlock(), _createBlock(_unref(Fold), { key: 1 }))
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_3, "建研国检智能检测系统", 512), [
            [_vShow, showTitle.value && !isSidebarCollapsed.value]
          ])
        ]),
        _createVNode(_component_el_menu, {
          "default-active": activeMenu.value,
          active: activeMenu.value,
          collapse: isSidebarCollapsed.value,
          class: "side-menu",
          "text-color": "#bfcbd9",
          "active-text-color": "#ffffff",
          "background-color": "#001529",
          "collapse-transition": false,
          onSelect: handleSelect
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidebarMenus.value, (item) => {
              return (_openBlock(), _createBlock(SidebarMenuItem, {
                key: item.id || item.path,
                item: item,
                "is-collapse": isSidebarCollapsed.value
              }, null, 8, ["item", "is-collapse"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active", "active", "collapse"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["content-container", { expanded: isSidebarCollapsed.value }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(BreadcrumbTitle.value), 1),
            (Breadcrumb.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " / "))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(Breadcrumb.value), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (currentUserName.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(User))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", { title: currentUserName.value }, _toDisplayString(currentUserName.value), 9, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_icon, {
              class: "logout-icon",
              title: "退出登录"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SwitchButton), { onClick: logout })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_tabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
              type: "card",
              closable: "",
              onTabRemove: removeTab,
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: tab.path,
                    label: tab.title,
                    name: tab.path,
                    closable: tab.path !== '/home',
                    onClose: ($event: any) => (removeTab(tab.path))
                  }, null, 8, ["label", "name", "closable", "onClose"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: closeOtherTabs,
                disabled: !canCloseOtherTabs.value
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("关闭其他")
                ])),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_button, {
                size: "small",
                onClick: closeAllTabs,
                disabled: tabs.value.length <= 1
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("全部关闭")
                ])),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component, route }) => [
              (_openBlock(), _createBlock(_KeepAlive, {
                exclude: noCacheRoutes.value,
                max: tabs.value.length + 1
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  key: getCacheKey(route.fullPath)
                }))
              ], 1032, ["exclude", "max"]))
            ]),
            _: 1
          })
        ])
      ], 2)
    ])
  ], 4))
}
}

})